export default __webpack_public_path__ + "static/media/green_circle.9ade2d28.svg";